<div class="quick-bet-skeleton">
    <div class="placeholder quick-bet-skeleton__header"></div>
    <div class="quick-bet-skeleton__body">
        <div class="placeholder quick-bet-skeleton__body__close"></div>
        <div class="placeholder quick-bet-skeleton__body__picks"></div>
        <div class="placeholder quick-bet-skeleton__body__odds"></div>
        <div class="placeholder quick-bet-skeleton__body__stake-container"></div>
    </div>
    <div class="quick-bet-skeleton__footer">
        <div class="placeholder quick-bet-skeleton__footer__cta"></div>
        <div class="placeholder quick-bet-skeleton__footer__cta"></div>
    </div>
</div>
